import React, { Component } from 'react';
import Button from 'antd/es/button';
import './App.css';
import MapContainer from './MapContainer'
import NavBar from './NavBar'
import Criteria from './Criteria'
import Features from './Features'
import Distributions from './Distributions'
import { object } from 'prop-types';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      mode: "grid",
      weights: {
        load: 50,
        cstru: 50,
      },
      features: {
        // far: 40,
        // diversity: 39,
        // score: 12
      },
      distributions: {
        // far: [2, 1, 23, 12, 21, 12, 3, 12, 3, 123],
        // diversity: [2, 1, 23, 12, 21, 12, 3, 12, 3, 123],
        // score: [2, 1, 23, 12, 21, 12, 3, 12, 3, 123]
      }
    }
  }

  onloaded = (e) => {
    this.setState({ loaded: true });
  }

  setMode = (e) => {
    this.setState({ mode: e })
  }

  /**
   * Criteria weight changed
   * @param e
   * @example
   * onChangeWeight({Load:20})
   */
  onChangeWeight = (e) => {
    let value = Object.assign({}, this.state.weights)
    value = Object.assign(value, e);
    this.setState((prevState) => {return{ weights: value }});
  }

  onChangeFeatures=(e)=>{
    if (JSON.stringify(e) != "{}") e["peak load"] = e["peak load"]/ 1000000; // peak load unit: W --> MW
    this.setState({ features: e })
  }

  render() {
    return (
      <div className="App">
        <div className="Loading" style={{ display: this.state.loaded ? "none" : "initial" }}>
          Loading...
        </div>
        <div className="Content">
          <NavBar
            mode={this.state.mode}
            setMode={this.setMode}
          />
          <div className="Side">
            <div>
              <img className="Logo" src="./logo.png" />
            </div>
            <div className="SideContent">
              <Criteria
                onChangeWeight={this.onChangeWeight}
                weights={this.state.weights} />
              <Features
                mode={this.state.mode}
                features={this.state.features}
              />
              {this.state.mode == 'grid' ?
                <Distributions
                  distributions={this.state.distributions}
                  features={this.state.features} />
                : null}
            </div>
          </div>
          <MapContainer
            loaded={this.state.loaded}
            mode={this.state.mode}
            weights={this.state.weights}
            features={this.state.features}
            distributions={this.distributions}
            onloaded={this.onloaded}
            onChangeFeatures={this.onChangeFeatures}
            onChangeDistributions={(e) => {this.setState({ distributions: e })}}
          />
        </div>
      </div>
    );
  }
}

export default App;